import { Popover } from 'antd';
import React from 'react';

/** 与 `public/static/contact.jpg` 对应，构建后由 Umi 按根路径提供 */
export const CONTACT_QR_PUBLIC_PATH = '/static/contact.jpg';

const contactQrContent = (
  <img
    src={CONTACT_QR_PUBLIC_PATH}
    alt=""
    width={160}
    height={160}
    style={{ display: 'block', verticalAlign: 'top' }}
  />
);

type CustomerServiceHoverQrProps = {
  children: React.ReactElement;
  placement?: 'top' | 'bottom' | 'left' | 'right';
};

/** 悬停展示客服二维码（与 ContentToolbar 客服一致） */
export const CustomerServiceHoverQr: React.FC<CustomerServiceHoverQrProps> = ({
  children,
  placement = 'bottom',
}) => (
  <Popover
    content={contactQrContent}
    trigger="hover"
    placement={placement}
    mouseEnterDelay={0.05}
  >
    {children}
  </Popover>
);
